import { useStateManager } from "@bcm-dev/bcms-vite";
import CountriesCustomSelect from "components/custom-ui/CountriesCustomSelect";
import StatesCustomSelect from "components/custom-ui/StatesCustomSelect";
import { FormRowView } from 'components/shared';
import { UICheckbox, UITextInput } from 'components/ui';
import React from 'react';
import FinancialInstitutionForm from "../FinancialInstitutionForm";

/**
 * @function DomesticDetailsFormView
 * @return {React.Component}
 * @exported true
 * @description The form for the payee details, both domestic and international.
 */

export default function PayeeDetailsFormView(props){
  const { data, onChange } = useStateManager();
  const payee = data.payee ?? {};
  
  return(
    <div className="domestic-details-form-view">
        <FormRowView text="* Address Line 1">
          <UITextInput value={ payee.addressLine1 } onChange={ onChange("addressLine1") } />
        </FormRowView>
        <FormRowView text="Address Line 2">
            <UITextInput value={ payee.addressLine2 } onChange={ onChange("addressLine2") } />
        </FormRowView>
        <FormRowView text="* City">
            <UITextInput value={ payee.city } onChange={ onChange("city") } />
        </FormRowView>
        { payee.addressType === "Domestic" &&
        <>
          <FormRowView text="* State">
            <StatesCustomSelect value={ payee.state } onChange={ onChange("state") }/>
          </FormRowView>
          <FormRowView text="* ZIP Code">
              <UITextInput value={ payee.zip } onChange={ onChange("zip") } />
          </FormRowView>
        </>
        }
        { payee.addressType === "Foreign" &&
        <>
          <FormRowView text="State or Province">
            <UITextInput value={ payee.stateOrProvidence } onChange={ onChange("stateOrProvidence") }/>
          </FormRowView>
          <FormRowView text="Postal Code">
              <UITextInput value={ payee.postalCode } onChange={ onChange("postalCode") }/>
          </FormRowView>
          <FormRowView text="* Country">
          <CountriesCustomSelect value={ payee.country } onChange={ onChange("country") }/>
        </FormRowView>
        </>
        }
        <b className="form-heading">Payee Financial Institution</b>
       <FinancialInstitutionForm formType="payeeFinancialInstitution" />

        <b className="form-heading">Receiving Financial Institution (optional)</b>
        <FormRowView>
          <UICheckbox onChange={ onChange("requiresReceivingFinancialInstitutionDetails") } label="This payee requires receiving financial institution details" />
        </FormRowView>
        { payee.requiresReceivingFinancialInstitutionDetails && <FinancialInstitutionForm formType="receivingFinancialInstitution" /> }

        <b className="form-heading">Intermediary Financial Institution (optional)</b>
        <FormRowView>
            <UICheckbox onChange={ onChange("requiresIntermediaryFinancialInstitutionDetails") } label="This payee requires intermediary financial institution details" />
        </FormRowView>
        { payee.requiresIntermediaryFinancialInstitutionDetails && <FinancialInstitutionForm formType="intermediaryFinancialInstitution" /> }
    </div>
  );
}